import { Factory } from 'impermax-sdk';
import { useContext } from 'react';
import FactoryContext from '../contexts/Factory';

export default function useFactory() : Factory {
  const factory = useContext(FactoryContext);
  return factory;
};